import * as React from "react";

const GourmetIconSvg = ({ size = 20, color = "#404548", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8083 18.3334H4.14166C1.64166 18.3334 1.64166 17.2084 1.64166 15.8334V15.0001C1.64166 14.5417 2.01666 14.1667 2.475 14.1667H17.475C17.9333 14.1667 18.3083 14.5417 18.3083 15.0001V15.8334C18.3083 17.2084 18.3083 18.3334 15.8083 18.3334Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2667 10.8334V14.1667H2.72501V10.8334C2.72501 7.63341 4.98334 4.95841 7.99167 4.31675C8.44167 4.21675 8.90834 4.16675 9.39167 4.16675H10.6C11.0833 4.16675 11.5583 4.21675 12.0083 4.31675C15.0167 4.96675 17.2667 7.63341 17.2667 10.8334Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0833 3.75008C12.0833 3.95008 12.0583 4.13341 12.0083 4.31675C11.5583 4.21675 11.0833 4.16675 10.6 4.16675H9.39167C8.90834 4.16675 8.44167 4.21675 7.99167 4.31675C7.94167 4.13341 7.91667 3.95008 7.91667 3.75008C7.91667 2.60008 8.85001 1.66675 10 1.66675C11.15 1.66675 12.0833 2.60008 12.0833 3.75008Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 9.16675H7.5"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GourmetIconSvg;